import Vue from 'vue';
import StudipIcon from '../StudipIcon.vue';
export default Vue.extend({
    name: 'NavigationItem',
    components: { StudipIcon },
    props: {
        item: {
            type: Object,
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        },
        isCourse: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        iconUrl() {
            if (this.item.icon && !this.item.icon.match(/^https?:\/\//)) {
                return window.STUDIP.ASSETS_URL + this.item.icon;
            }
            return this.item.icon;
        },
    },
    methods: {
        getUrl(url) {
            return window.STUDIP.URLHelper.getURL(url);
        },
        moveTo(path) {
            window.STUDIP.eventBus.emit('responsive-navigation-move-to', path);
        },
        hasChildren() {
            return this.item.children && Object.keys(this.item.children).length > 0;
        },
        navigateToText(itemTitle) {
            return this.$gettextInterpolate(this.$gettext('Navigiere zu %{ title }'), { title: itemTitle });
        },
        openNavigationText(itemTitle) {
            return this.$gettextInterpolate(this.$gettext('Unternavigation zu %{ title } öffnen'), {
                title: itemTitle,
            });
        },
    },
});
